"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BrandIcons = require("../BrandIcons");

var _core = require("@emotion/core");

var SvgBCashRecievePositive = function SvgBCashRecievePositive(props) {
  return (0, _core.jsx)(_BrandIcons.BrandIcons, props, (0, _core.jsx)("g", {
    fill: "none",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M72.503 68.777a2.097 2.097 0 01-2.097-2.097V51.61a2.097 2.097 0 114.194 0v15.07a2.097 2.097 0 01-2.097 2.097z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M72.503 53.252a11.43 11.43 0 01-7.864-3.04 2.097 2.097 0 012.873-3.055 7.256 7.256 0 004.991 1.9c3.761 0 6.816-2.655 6.816-5.92 0-3.537-3.495-5.662-6.99-5.949a14.421 14.421 0 01-3.824-.838c-4.3-1.734-6.99-5.292-6.99-9.29 0-5.649 4.935-10.185 11.002-10.185a11.485 11.485 0 017.732 2.908 2.097 2.097 0 01-2.797 3.11 7.249 7.249 0 00-4.893-1.824c-3.81.02-6.85 2.698-6.85 5.941 0 2.356 1.621 4.376 4.34 5.467a10.17 10.17 0 002.643.531c6.291.517 10.835 4.768 10.835 10.108-.014 5.6-4.956 10.136-11.024 10.136z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M72.503 70.19h-.056c-19.189-.273-34.601-15.908-34.6-35.099C37.85 15.901 53.266.27 72.455 0h.042c1.159 0 2.097.939 2.097 2.097V19.09a2.097 2.097 0 11-4.194 0V4.264C53.812 5.436 41.126 19.522 41.69 36.141c.565 16.618 14.178 29.811 30.806 29.854 14.222.018 26.62-9.673 30.037-23.478 3.417-13.805-3.028-28.16-15.616-34.779a2.098 2.098 0 111.958-3.712c14.287 7.514 21.607 23.803 17.74 39.475-3.869 15.672-17.927 26.685-34.07 26.689h-.042zM64.716 131.46a32.561 32.561 0 01-10.192-1.65 2.099 2.099 0 011.321-3.985 28.136 28.136 0 0024.047-2.999l57.684-36.79a4.683 4.683 0 00.699-7.374 6.613 6.613 0 00-7.319-1.168l-37.65 17.427a2.097 2.097 0 01-1.761-3.803l37.65-17.433a10.793 10.793 0 0111.939 1.908 8.878 8.878 0 01-1.28 13.98l-57.683 36.784a32.31 32.31 0 01-17.455 5.102z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M74.915 108.916c-.797-.001-1.59-.1-2.363-.294l-33.406-8.276a2.097 2.097 0 011.006-4.069l33.4 8.277a5.376 5.376 0 003.495-10.108L43.284 79.647a32.085 32.085 0 00-35.881 6.676l-3.118 3.153a2.097 2.097 0 11-2.978-2.95l3.11-3.153a36.3 36.3 0 0140.545-7.563l33.812 14.805a9.563 9.563 0 011.02 16.93 9.465 9.465 0 01-4.879 1.37z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M64.716 131.46a32.56 32.56 0 01-10.192-1.65L22.3 119.163a2.098 2.098 0 111.314-3.984l32.211 10.646a28.136 28.136 0 0024.047-2.999l57.684-36.79a2.098 2.098 0 012.258 3.538l-57.684 36.783a32.31 32.31 0 01-17.413 5.102z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M74.915 108.916c-.797-.001-1.59-.1-2.363-.294l-33.406-8.276a2.097 2.097 0 011.006-4.069l33.4 8.277a5.362 5.362 0 006.557-3.894 2.098 2.098 0 114.075 1 9.57 9.57 0 01-9.269 7.29v-.034z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M94.6 12.68a2.097 2.097 0 01-1.398-.538 30.757 30.757 0 00-8.43-5.424 2.1 2.1 0 011.67-3.852 34.951 34.951 0 019.57 6.165 2.097 2.097 0 01-1.398 3.65H94.6z",
    fill: "#1B7"
  })));
};

var _default = SvgBCashRecievePositive;
exports["default"] = _default;